import { axiosCmsAPI, axiosContentDetail, axiosWebinarManagement } from "../axios";
import { EVENT_ACTIONS } from "./actionTypes";
import { handleActionError } from "../util/error";
import { getContentWithLanguage } from "../util/language";

const eventApiId = "/api/event/get-event-by-id";

export const getEventDataAction = eventId => {
  return dispatch => {
    return axiosWebinarManagement
      .get(`${eventApiId}?id=${eventId}`)
      .then(response => {
        if (response.data.data && Object.keys(response.data.data).length === 0 && response.data.data.constructor === Object) {
          dispatch({
            type: EVENT_ACTIONS.EVENT_DATA._FAILURE
          });
        } else {
          const { data = {} } = response;
          dispatch({
            type: EVENT_ACTIONS.EVENT_DATA._SUCCESS,
            payload: { data: data.data }
          });
        }
      })
      .catch(error => {
        handleActionError("Error fetching event data", error);
        dispatch({
          type: EVENT_ACTIONS.EVENT_DATA._FAILURE
        });
      });
  };
};

export const getEvent = (eventId, language) => {
    return async (dispatch) => {
      dispatch({
        type: EVENT_ACTIONS.EVENT_DATA._START,
      });
      try {
        const response = await axiosCmsAPI.get(`/events/${eventId}`);
        const parsedLanguageData = getContentWithLanguage(response.data, language);
        let expertList = await getEventSpeakersList(response.data.experts, language);
  
        return dispatch({
          type: EVENT_ACTIONS.EVENT_DATA._SUCCESS,
          payload: {
            data: {
              event: parsedLanguageData,
              expertsList: expertList,
              isEventLoading: false,
            },
          },
        });
      } catch (error) {
        handleActionError("An error occurred while getting event data:", error);
        return dispatch({
          type: SERIES_PAGE_ACTIONS.SERIES_DETAIL._FAILURE,
          isEventLoading: false,
        });
      }
    }
  };

const getEventSpeakersList = async (speakers, language) => {
  const SubMenuUrl = "/api/v1/expert";
  let requests = speakers.map(async (speaker) => {
    let reqBody = {
      "id": speaker.id,
      "token": null
    };
    try {
      const response = await axiosContentDetail.post(`${SubMenuUrl}`, reqBody);
      const { data = {} } = response;
      let expert = await getContentWithLanguage(data.data, language);
      return expert;
    } catch (error) {
      console.log(`Error fetching expert data for id: ${speaker.id}`, error);
      return null;
    }
  });

  const list = await Promise.all(requests);
  
  return list.filter(expert => expert !== null);
}

export const getEventsList = (type) => {
  let previous_events = [];
  let upcoming_events = [];
  return dispatch => {
    dispatch({
      type: EVENT_ACTIONS.EVENT_LIST_DATA._START,
    });
    return axiosCmsAPI
      .get('/events?filter={"status":"ACTIVE"}')
      .then(response => {
        const currentTime = new Date();
        response.data.forEach(conference => {    
          currentTime < new Date(conference.event_date) ? upcoming_events.push(conference) : previous_events.push(conference);
        })
        if(type === "all") { 
          dispatch ({
            type: EVENT_ACTIONS.EVENT_LIST_DATA._SUCCESS,
            payload: {
              data: {
                previous_events: previous_events,
                upcoming_events: upcoming_events,
                isListLoading: false         
              },
            }
          })
        }
        if(type === "upcoming") {
          dispatch ({
            type: EVENT_ACTIONS.EVENT_LIST_DATA._SUCCESS,
            payload: {
              data: upcoming_events,
              isListLoading: false
            }
          })
        }
        if(type === "previous") {
          dispatch ({
            type: EVENT_ACTIONS.EVENT_LIST_DATA._SUCCESS,
            payload: {
              data: previous_events,
              isListLoading: false
            }
          })
        }
      })
    .catch(error => {
      handleActionError("An error occurred while getting event list data:", error);
      return dispatch ({
        type: EVENT_ACTIONS.EVENT_LIST_DATA._FAILURE,
        payload: {
          isListLoading: false,
        }        
      })
    });
  }
}
